export const employeeCostDetailsTableConfig = [
  {
    field: 'dateRange',
    header: 'Date',
    visible: false,
    filter: false,
    isGlobalFilter: true,
    sortable: true,
    order: 1,
    pinnable: false,
  },
  {
    field: 'year',
    header: 'Year',
    filter: false,
    visible: true,
    order: 6,
    width: 140,
    type: 'string',
    sortable: true,
  },
  {
    field: 'emp_id',
    header: 'TBH Id',
    filter: false,
    visible: false,
    showFilterButtonInHeader: true,
    defaultPinned: false,
    order: 7,
    width: 160,
    type: 'string',
    sortable: true,
    filterVisible: false,
    isGlobalFilter: true,
  },
  {
    field: 'month',
    header: 'Month',
    filter: false,
    visible: true,
    order: 9,
    type: 'month',
    sortable: true,
    width: 140,
  },
  {
    field: 'region_name',
    header: 'Employee Region',
    label: 'Employee Region',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 10,
    type: 'multiSelect',
    sortable: true,
    width: 160,
    menuItems: [],
  },
  {
    field: 'country_name',
    header: 'Employee Country',
    label: 'Employee Country',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 11,
    type: 'multiSelect',
    sortable: true,
    width: 170,
    menuItems: [],
  },
  {
    field: 'vertical_name',
    header: 'Employee Vertical',
    label: 'Employee Vertical',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 12,
    type: 'multiSelect',
    sortable: true,
    width: 170,
    menuItems: [],
  },
  {
    field: 'location_name',
    header: 'Employee Location',
    label: 'Employee Location',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 13,
    type: 'multiSelect',
    sortable: true,
    width: 170,
    menuItems: [],
  },
  {
    field: 'employee_type',
    header: 'Employee Contract Type',
    label: 'Employee Contract Type',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 14,
    type: 'string',
    sortable: true,
    width: 190,
    menuItems: [],
  },
  {
    field: 'role_name',
    header: 'Employee Role',
    label: 'Employee Role',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 15,
    type: 'multiSelect',
    sortable: true,
    width: 170,
    menuItems: [],
    align: 'left',
    headerAlign: 'left',
    className: 'employee-cost-role-column',
    headerClassName: 'employee-cost-role-column',
  },
  {
    field: 'experience_category',
    header: 'Experience Category',
    label: 'Experience Category',
    filter: false,
    visible: true,
    isGlobalFilter: true,
    order: 16,
    type: 'string',
    sortable: true,
    width: 120,
    menuItems: [],
    align: 'left',
    headerAlign: 'left',
    className: 'employee-cost-experience-column',
    headerClassName: 'employee-cost-experience-column',
  },
  {
    field: 'hourly_cost',
    header: 'Employee Per Hr Cost',
    filter: false,
    visible: true,
    order: 17,
    type: 'number',
    sortable: true,
    width: 170,
    align: 'right',
    headerAlign: 'right',
    className: 'employee-cost-number-column',
    headerClassName: 'employee-cost-number-column',
  },
  {
    field: 'department_name', // Ensure this key is returned by your API
    header: 'Employee Department',
    filter: false,
    visible: true,
    order: 18,
    type: 'string',
    sortable: true,
    width: 180,
    align: 'left',
    headerAlign: 'left',
    className: 'employee-cost-department-column',
    headerClassName: 'employee-cost-department-column',
  },
  {
    field: 'action',
    header: 'Action',
    className: 'employee-cost-action-column',
    headerClassName: 'employee-cost-action-column',
    width: 100,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 19,
    menuItems: [],
  },
];
